<hr />
<div class="row pb-1" *ngFor="let array of allValues; let idx = index">
	<div class="col-2" *ngIf="idx % 2 === 0 && idx % 3 === 0">
		<i class="cfe cfe-sun"></i>
	</div>
	<div class="col-2" *ngIf="idx % 2 === 0 && idx % 3 !== 0">
		<i class="cfe cfe-moon"></i>
	</div>
	<div class="col-2" *ngIf="idx % 2 !== 0"></div>
	<div class="col-8">
		<div class="row delivery-time" *ngFor="let number of array">
			<div
				class="col-2 time-item"
				*ngFor="let value of number; let idx2 = index"
				(click)="clickedHour(value, 6 * idx + idx2)"
				[ngClass]="{ active: activeHour === 6 * idx + idx2 }"
			>
				{{ value }}
			</div>
		</div>
	</div>
	<div class="col-2 ellipsis" *ngIf="idx === 0 || idx === 3">{{ 'inputTime.text.am' | translate }}</div>
	<div class="col-2 ellipsis" *ngIf="idx === 1 || idx === 2">{{ 'inputTime.text.pm' | translate }}</div>

	<div class="col-12" *ngIf="idx === 1">
		<hr />
	</div>
</div>
<hr />
<!--Minutes-->
<div class="row">
	<div class="col-2">{{ 'inputTime.text.minute' | translate }}</div>
	<div class="col-8">
		<div class="row delivery-time">
			<div class="col-2"></div>
			<div
				class="col-2 time-item"
				*ngFor="let minute of minutes; let idx = index"
				(click)="clickedMinute(minute, idx)"
				[ngClass]="{ active: activeMinute === idx }"
			>
				{{ minute }}
			</div>
			<div class="col-2"></div>
		</div>
	</div>
	<div class="col-2"></div>
</div>
